export default __webpack_public_path__ + "style-osm-night-800-212a9fb0caad2a8f7b9179a4963a8236.png";